<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/101GI7a/tc-custom/9781398400481.jpg?1684979381193" alt="This image is the cover for the book Flicker"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Flicker
      </h1>
      <p class="bookDescription body article font2">
        <p>After discovering that her nemesis is none other than her friend, Lexi must live to fight another day. But now he knows that she’s a witch. <br/>Can she survive long enough to her abusive step-father face justice, or are her days numbered? And can she carry on alone, or is there someone out there to help her?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        T.D. Holmes
      </h2>
      
      <p class="authorDescription body article">T.D. Holmes is a British author based in Northern Ireland, UK. Despite being dyslexic, she loves to read and after a traumatic experience, found solace in writing. Since then, her love for writing grew as she discovered a creative and vivid imagination. <br>She describes herself as nerdy with a sarcastic sense of humour. She loves everything Disney and sci-fi. From Doctor Who to Marvel and DC. She has a great love of foxes and dreams to start a conservation charity.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?79dc9fb3